import { path } from 'ramda'
import { getMessages } from './messages'

export const notificationTypes = {
  SYNC: 'loft-sync',
  ERROR: 'loft-error',
  INFO: 'loft-info',
  PROGRESS: 'loft-progress',
}

export const getErrorMessages = () => {
  const messages = getMessages()

  return {
    FAILURE: messages.errorMessageFailedSend,
    HANDLED_FAILURE: messages.errorMessageEmailReadyForLofting,
    INVALID_SESSION: messages.errorMessageSignIn,
    RECIPIENT_INVALID: messages.errorMessageRecipientInvalid,
    RECIPIENT_DNC: messages.errorMessageEmailContactRestrictions,
    RECIPIENT_INTERNAL_DOMAIN: messages.errorMessageEmailInTrackingExclusionList,
    SAVE_ERROR: messages.errorMessageConnectionError,
    INVALID_ATTENDEES: messages.errorMessageAttendeesInvalid,
    INVALID_RECURRENCE: messages.errorMessageRecurrenceNotSupported,
  }
}

export type LoftMessages = {
  preparing: string
  preparing_message: string
  connecting_server: string
  connecting_salesloft: string
  sending: string
  lofted: string
  appointmentLofted: string
}

export const getLoftMessages = (): LoftMessages => {
  const messages = getMessages()

  return {
    preparing: messages.textLoftMessageLoftingInProgress,
    preparing_message: messages.textLoftMessagePreparingMessage,
    connecting_server: messages.textLoftMessageConnectingToServer,
    connecting_salesloft: messages.textLoftMessageConnectingToSalesloft,
    sending: messages.textLoftMessageSendingMessage,
    lofted: messages.textLoftMessage,
    appointmentLofted: messages.textAppointmentLoftMessage,
  }
}

const blacklistMessages = {
  INVALID_BEARER_TOKEN: 'Invalid Bearer token',
}

export function fetchErrorMessage(error: string | Error) {
  const errorMessages = getErrorMessages()
  let errorMessage: string = errorMessages.FAILURE
  let shouldReport = false
  let shouldNotify = true
  const isKnown = (value: string) => Object.values(errorMessages).includes(value)

  if (typeof error === 'string' && isKnown(error)) {
    errorMessage = error
  } else if (error instanceof Error && isKnown(error.message)) {
    errorMessage = error.message
  } else if (path(['response', 'data', 'error'], error)) {
    errorMessage = path(['response', 'data', 'error'], error) || ''

    shouldNotify = !Object.values(blacklistMessages).includes(errorMessage)
  } else {
    shouldReport = true
  }

  return { errorMessage, shouldReport, shouldNotify }
}
